function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Configuration } from "../Shared/Configuration";
import { Ajax } from "./Ajax";
export var EventsApiService = /*#__PURE__*/function () {
  function EventsApiService() {
    _classCallCheck(this, EventsApiService);

    var config = new Configuration();
    this._appRoot = config.GetAppRoot();
  }

  _createClass(EventsApiService, [{
    key: "GetMyEvents",
    value: function GetMyEvents(eventDate) {
      var url = "".concat(this._appRoot, "/Api/EventsApi/GetMyEvents?eventDate=").concat(eventDate);
      return Ajax.Get(url);
    }
  }, {
    key: "GetQRCode",
    value: function GetQRCode(eventDate) {
      var url = "".concat(this._appRoot, "/Api/EventsApi/GetQRCode?eventDate=").concat(eventDate);
      return Ajax.Get(url);
    }
  }, {
    key: "SavePreCheck",
    value: function SavePreCheck(eventDate, formData) {
      var url = "".concat(this._appRoot, "/Api/EventsApi/SavePreCheck?eventDate=").concat(eventDate);
      return Ajax.Post(url, formData);
    }
  }, {
    key: "GetEvents",
    value: function GetEvents(formData) {
      var url = "".concat(this._appRoot, "/Api/EventsApi/GetEvents");
      return Ajax.Post(url, formData);
    }
  }, {
    key: "GetEventRegistrationTotal",
    value: function GetEventRegistrationTotal(formData) {
      var url = "".concat(this._appRoot, "/Api/EventsApi/GetEventRegistrationTotal");
      return Ajax.Post(url, formData);
    }
  }, {
    key: "GetEventDetail",
    value: function GetEventDetail(id) {
      var url = "".concat(this._appRoot, "/Api/EventsApi/GetEvent/").concat(id);
      return Ajax.Get(url).then(function (response) {
        return response;
      })["catch"]( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(error) {
          var _errorJson$message;

          var errorJson;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return error.json();

                case 2:
                  errorJson = _context.sent;
                  throw new Error((_errorJson$message = errorJson.message) !== null && _errorJson$message !== void 0 ? _errorJson$message : "Failed to load event data.");

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "GetEventParticipantsByInvoice",
    value: function GetEventParticipantsByInvoice(id) {
      var url = "".concat(this._appRoot, "/Api/EventsApi/GetEventParticipantsByInvoice/").concat(id);
      return Ajax.Get(url);
    }
  }, {
    key: "GetEventUserContact",
    value: function GetEventUserContact(id) {
      var url = "".concat(this._appRoot, "/Api/ContactsApi/GetCurrentBasicContact");
      return Ajax.Get(url);
    }
  }, {
    key: "GetConfigurations",
    value: function GetConfigurations() {
      var url = "".concat(this._appRoot, "/Api/EventsApi/GetConfigurations");
      return Ajax.Get(url);
    }
  }, {
    key: "SaveRegistration",
    value: function SaveRegistration(formData) {
      var url = "".concat(this._appRoot, "/Api/EventsApi/SaveRegistration");
      return Ajax.Post(url, formData);
    }
  }, {
    key: "PayInvoice",
    value: function PayInvoice(invoiceId, amount) {
      var url = "".concat(this._appRoot, "/Api/EventsApi/PayInvoice");
      return Ajax.Post(url, {
        invoiceId: invoiceId,
        amount: amount
      });
    }
  }, {
    key: "HasRegistered",
    value: function HasRegistered(eventId, contactId) {
      var url = "".concat(this._appRoot, "/Api/EventsApi/HasRegistered?eventId=").concat(eventId).concat(!!contactId ? "&contactId=".concat(contactId) : "");
      return Ajax.Get(url);
    }
  }, {
    key: "CheckAvailability",
    value: function CheckAvailability(formData) {
      var url = "".concat(this._appRoot, "/Api/EventsApi/CheckAvailability");
      return Ajax.Post(url, formData);
    }
  }, {
    key: "GetBaseInvoiceDetail",
    value: function GetBaseInvoiceDetail(eventParticipantId) {
      var url = "".concat(this._appRoot, "/Api/EventsApi/GetInvoiceDetailByParticipantId/").concat(eventParticipantId);
      return Ajax.Get(url);
    }
  }, {
    key: "CheckPendingEventAvailability",
    value: function CheckPendingEventAvailability(eventId) {
      var url = "".concat(this._appRoot, "/Api/EventsApi/CheckPendingEventAvailability?eventId=").concat(eventId);
      return Ajax.Get(url);
    }
  }]);

  return EventsApiService;
}();